/**
 * Real API implementation for Initial Setup.
 * POST /api/v3/initial-setup – One-time call after primary-organization admin accepts invitation.
 * Creates user profile and organization in a single transaction.
 * Permission: primary-organization scope with organizationId: null.
 * Response: { success, data: { user, organization } }. After success → redirect to onboarding wizard.
 */

import { apiClient } from '../apiClient';

const INITIAL_SETUP_PATH = '/api/v3/initial-setup';

export const initialSetup = async (payload) => {
  const response = await apiClient.post(INITIAL_SETUP_PATH, payload);
  return response.data;
};
